import { useContext, useEffect, useRef, useState } from "react";
import { FaPause, FaPlay } from "react-icons/fa";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { VECNO_UNIT } from "../explorer_constants";
import { numberWithCommas } from "../helper";
import LastBlocksContext from "./LastBlocksContext";

const TxOverview = (props) => {
  const [tempBlocks, setTempBlocks] = useState([]);
  const [keepUpdating, setKeepUpdating] = useState(true);
  const [ignoreCoinbaseTx] = useState(false);

  const keepUpdatingRef = useRef();
  keepUpdatingRef.current = keepUpdating;

  const { blocks, isConnected } = useContext(LastBlocksContext);
  const navigate = useNavigate();

  const onClickRow = (e) => {
    const row = e.target.closest("tr");
    navigate(`/txs/${row.getAttribute("txid")}?blockHash=${row.getAttribute("blockHash")}`);
  };

  const onClickAddr = (e) => {
    navigate(`/addresses/${e.target.closest("tr").getAttribute("id")}`);
  };

  // Function to shorten address
  const shortenHash = (hash) => {
    if (!hash) return "";
    return `${hash.slice(0, 6)}...${hash.slice(-6)}`;
  };

  useEffect(() => {
    if (keepUpdatingRef.current) {
      setTempBlocks(blocks);
    }
  }, [blocks]);

  return (
    <div className="block-overview mb-4">
      <div className="d-flex flex-row w-100">
        {!keepUpdating ? (
          <FaPlay
            id="play-button"
            className="play-button"
            onClick={() => setKeepUpdating(true)}
          />
        ) : (
          <FaPause
            id="pause-button"
            className="play-button"
            onClick={() => setKeepUpdating(false)}
          />
        )}
        <h4 className="block-overview-header text-center w-100 me-4">
          <RiMoneyDollarCircleFill
            className={isConnected && keepUpdating ? "rotate" : ""}
            size="1.7rem"
          />{" "}
          LATEST TRANSACTIONS
        </h4>
      </div>
      <div className="block-overview-content">
        <table className="styled-table w-100">
          <thead>
            <tr>
              <th>Id</th>
              <th>Amount</th>
              <th width="100%">Recipient</th>
            </tr>
          </thead>
          <tbody>
            {[...tempBlocks]
              .sort((a, b) => b.blueScore - a.blueScore)
              .flatMap((block) =>
                block.txs
                  .slice(ignoreCoinbaseTx ? 1 : 0)
                  .flatMap((tx) =>
                    tx.outputs.flatMap((output, outputIndex) => ({
                      amount: output[1],
                      address: output[0],
                      txId: tx.txId,
                      blockHash: block.block_hash,
                      outputIndex,
                    }))
                  )
              )
              .filter(
                (v, i, a) =>
                  a.findIndex((v2) => {
                    const { blockHash: _, ...vWithoutBlockHash } = v;
                    const { blockHash: __, ...v2WithoutBlockHash } = v2;
                    return JSON.stringify(vWithoutBlockHash) === JSON.stringify(v2WithoutBlockHash);
                  }) === i
              )
              .slice(0, props.lines)
              .map((x) => (
                <tr
                  id={x.address}
                  txid={x.txId}
                  key={x.address + x.txId + x.outputIndex}
                  blockHash={x.blockHash}
                >
                  <td onClick={onClickRow} data-label="Id">{x.txId.slice(0, 10)}</td>
                  <td onClick={onClickRow} align="right" data-label="Amount">
                    {numberWithCommas(x.amount / 100000000)}&nbsp;{VECNO_UNIT}
                  </td>
                  <td className="hash-cell" onClick={onClickAddr} data-label="Recipient" title={x.address}>
                    {shortenHash(x.address)}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TxOverview;